<div class="login-inside-container" id="div_login-inside-container_d974b9c5">
  <h1 aria-label="EMAIL SENT" title="EMAIL SENT" id="h1_dd7c019b">
    EMAIL SENT.
  </h1>
  <label id="label_1c2996d9"
    >Welcome! Please register your account by following the link in the email we
    just sent. <br />
    The link will expire in 10 minutes</label
  >
  <div class="btn-panel" id="div_btn-panel_ec3e8eac">
    <p id="p_76b526cb">
      Didn't get an email?
      <a
        aria-label="Resend"
        title="Resend"
        (click)="resendEmail()"
        id="a_748bccd0"
        >Resend</a
      >
    </p>
  </div>
</div>

<p-toast
  position="top-center"
  life="500000"
  key="toast"
  id="p-toast_e2641bb4"
></p-toast>
